module.exports = __webpack_public_path__ + "static/MediumLogo-a921d0343ae89048e1e3060fa712408b.png";